import { render } from "./index.vue?vue&type=template&id=9c27cb0c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/layouts/VabEmptyLayout/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c27cb0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c27cb0c', __exports__)) {
    console.log('reload')
    api.reload('9c27cb0c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=9c27cb0c", () => {
    console.log('re-render')
    api.rerender('9c27cb0c', render)
  })

}


export default __exports__